const isFeatureEnabled = (state, feature) => {
  const features = state.institution.features || {};
  return features[feature] === 'on';
};

export const bbbEnabled = (state) =>
  isFeatureEnabled(state, 'FEAT_BIG_BLUE_BUTTON');
export const bbbEnabledInConversations = (state) =>
  isFeatureEnabled(state, 'FEAT_BIG_BLUE_BUTTON_IN_DMS');

export const engagementInsightsEnabled = (state) =>
  isFeatureEnabled(state, 'FEAT_ENGAGEMENT_INSIGHTS');

const institution = (state) => state.institution;

export const institutionName = (state) => institution(state).name;

export const baseDomain = (state) => {
  const {
    institution: {
      general: { base_domain: domain },
    },
  } = state;
  return domain;
};
